<template>
    <div class="col-4 mb-3 pr-0">
        <div class="my-card-numbers">
            <div class="my-card-numbers-icon">
                <i class="bx bx-bar-chart-alt"></i>
            </div>
            <div>
                <h4>{{ values.total }}</h4>
                <p class="title">{{ label }}</p>
                <p>{{ sublabel }}</p>
            </div>
            <div class="text-right">
                <h4> {{ porcentagemFormatada }}</h4>
                <p class="mb-0 color-gray">Mês anterior</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        values: {
            type: [Array, Object],
            required: true
        },
        label: {
            type: String,
            required: true
        },

        sublabel: {
            type: String,
            required: false
        }
    },
    computed: {
        porcentagemValor() {
            if (this.values && this.values.anterior && this.values.anterior != 0) {
                return ((this.values.total - this.values.anterior) / this.values.anterior) * 100;
            }
            if (this.values && this.values.anterior == 0 && this.values.total > 0) {
                return 100;
            }
            return null;
        },
        porcentagemFormatada() {
            if (this.porcentagemValor !== null) {
                const val = this.porcentagemValor;
                return val.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            return "--";
        }
    }
};
</script>
<style scoped>

</style>